import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppButton from "@/components/buttons/AppButton";
import NoDataAvailable from "@/components/cards/NoDataAvailable";
import { AssignmentListPageSkeleton } from "@/components/skeletons";
import { getUserById } from "@/services/user.service";
import { BUTTONS } from "@/utils/constants/appConstants/commonConstants";
import { useFeaturePermission } from "@/utils/hooks/useFeaturePermission";
import { NO_GROUP_ASSIGNED } from "@/utils/constants/messages";
import { getUserId } from "@/utils/functions/TokenFunction";
import { FEATURE_PERMISSIONS } from "@/utils/constants/featurePermissions";

const UserGroup = () => {
    const params = useParams();
    const id = params.id || "";
    const currentUserId = getUserId();
    const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState<any>({});
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setIsLoading(true);
        getUserById(
            id,
            (response: any) => {
                setIsLoading(false);
                setUserDetails(response.data);
            },
            (error: any) => {
                setIsLoading(false);
                console.log(error);
            }
        );
    }, [id]);
    /**
     * RBAC BEGIN
     */
    const isUpdateUserPermission = useFeaturePermission(FEATURE_PERMISSIONS.AdminPortalUpdateUser);
    /**
     * RBAC END
     */
    if (isLoading) {
        return <AssignmentListPageSkeleton sectionTitle="Groups" />;
    }

    return (
        <>
            <div className="flex items-start justify-between gap-3 mb-4">
                <h3 className="text-xl font-normal leading-snug text-secondary" id='user-group-email-address'>{userDetails?.email_address}</h3>
                {isUpdateUserPermission && !!userDetails && currentUserId !== userDetails?.id && <AppButton id='user-group-edit-btn' onClick={() => navigate(`/user/${userDetails?.id}/groups/update`)} btnText={BUTTONS.EDIT} className="btn-primary" isLoading={false} />}
            </div>
            <h5 style={{ padding: "1.25rem 0 0.75rem", fontWeight: 500 }} id='user-group-title'>Group</h5>
            <div className="gs-list-page-card">
                <ul className="gs-detail-list gs-assignment-name-list">
                    {userDetails?.organizations && userDetails?.organizations[0]?.groups.length > 0 ? (
                        userDetails.organizations[0].groups.map((group: any, key: string) => (
                            <li className="gs-detail-list-item" key={key}>
                                <div className="gs-detail-list-name" id={`user-group-name-${key}`}>{group.name}</div>
                            </li>
                        ))
                    ) : (
                        <li className="gs-detail-list-item">
                            <NoDataAvailable><p id='no-group-assigned'>{NO_GROUP_ASSIGNED}</p></NoDataAvailable>
                        </li>
                    )}
                </ul>
            </div>
        </>
    );
};

export default UserGroup;
